const einDashboard = {
  einDashboard: {
    installingSince: 'Installazione di Enphase da',
    accountManager: 'Responsabile account',
    installationShare: 'Quota di installazioni Enphase',
    nps: 'Net Promoter Score',
    viewDashboard: 'Visualizza dashboard',
    quarterInfo: 'a partire dal Q%{quarter},%{year} (residenziale)',
    npsTooltip: `Il Net Promoter Score è un indice che spazia da -100 a 100 e che misura la volontà dei clienti a raccomandare ad altri i prodotti o i servizi di un'azienda. Questo punteggio si basa sulle valutazioni fornite dai tuoi clienti nell'app mobile di Enlighten riguardo ai tuoi servizi, ed è visibile solo a te e a Enphase. Il periodo temporale predefinito per i dati è degli ultimi 13 mesi.`,
    activity: 'Attività',
    sites: 'Siti',
    batteries: 'Batterie',
    acb: 'ACB',
    certifications: 'Certificazioni',
    community: 'Community',
    storage: 'Siti di stoccaggio',
    lastInstalledLabel: 'installati negli ultimi 12 mesi',
    lastCommissionedLabel: 'messi in servizio negli ultimi 12 mesi',
    viewDetails: 'Visualizza dettagli',
    seeReviews: 'Guarda recensioni',
    viewCommunity: 'Visualizza community',
    certificateLabel: '%{count} certificazioni su %{totalCount} completate',
    networkLabel: {
      one: '%{count} post, ultimo post: %{postDate}',
      other: '%{count} post, ultimo post: %{postDate}'
    },
    requestProductAccess: 'Richiedi accesso al prodotto',
    inverter: 'IQ-8',
    ensemble: 'Ensemble 2.0',
    permit: 'Assistenza consentita',
    sgip: 'Assistenza SGIP',
    learnMore: 'Maggiori informazioni',
    aboutProduct: 'sul prodotto',
    betaReleaseDate: 'Data versione beta',
    requestEarlyAccess: 'Richiesti accesso anticipato',
    viewAllProduct: 'Visualizza tutti i prodotti',
    signUp: 'Registrami',
    betaReleaseLabel: 'per tutte le nuove versioni beta dei prodotti',
    financing: 'Supporto finanziario',
    digitalPlatform: 'Piattaforma digitale',
    lpp: 'LPP',
    requestedText: "Richiesta inviata per l'accesso anticipato",
    grantedText: 'Accesso beta concesso',
    products: 'Prodotti',
    ratingsReviews: 'Valutazioni e recensioni',
    reviews: 'Recensioni',
    otherReviews: 'Altre recensioni',
    updateDetails: 'Aggiorna dettagli',
    totalSavings: 'Salvataggi totali',
    inLastYear: 'Negli ultimi 12 mesi',
    viewBreakdown: 'Visualizza suddivisione',
    leadsReceived: 'Lead ricevuti',
    leadsClosure: 'Chiusura lead',
    leadsWon: 'Lead conquistati',
    creditAvailable: 'Credito disponibile',
    buyMore: 'Acquista altro',
    messageFromCeo: 'Messaggio dal nostro CEO',
    communityUpdates: 'Aggiornamenti della community',
    makeAppointments: 'Prendi appuntamenti',
    applicableText: 'Applicabile solo ai membri Platinum',
    view: 'Visualizza',
    downloadAll: 'Scarica tutto',
    promoteText: 'Promuovi la tua azienda con badge e loghi',
    asOfText: 'A partire da: %{date}',
    yearTotal: 'Totale/anno',
    redeemed: 'Riscattato',
    laborProtectionPlan: 'Programma di tutela del lavoro',
    acmPromotion: 'Promozione ACM',
    save: {
      lre_data: 'Risparmi da LPP',
      permit_data: 'Risparmi da Autorizzazione',
      financing_data: 'Risparmi da Finanziamento',
      sgip_data: 'Risparmi da SGIP',
      warrantyExtension: "Risparmi sull'estensione della garanzia"
    },
    platinumLogo: 'Logo Platinum',
    enphaseLogo: 'Logo Enphase',
    otherAssets: 'Altre risorse',
    ensembleCertificate: 'Certificato Ensemble 1.0',
    salesCertificate: 'Certificato Sales 1.0',
    marketingCertificate: 'Certificato Marketing 1.0',
    solarInstallCertificate: 'Certificazione Solar Install',
    validTill: 'Valido fino a: %{date}',
    noDataAvailable: 'Nessun dato disponibile',
    notAvailable: 'Non disponibile',
    notApplicable: 'Non applicabile',
    title: 'Dashboard EIN',
    congratulationSignUp:
      "Congratulazioni! Adesso usufruirai dell'accesso anticipato a ogni nuovo prodotto/servizio Enphase",
    benefits: 'Vantaggi',
    installationShareTooltip:
      'Questo numero indica quale percentuale delle tue installazioni complessive è composta da installazioni Enphase',
    dataFromThirdParty: '*In base ai dati offerti da una fonte di terze parti',
    reviewsNotAvailable: 'Nessuna recensione disponibile',
    enphaseExecutive: 'Dirigente Enphase',
    digitalAssets: 'Risorse digitali',
    leads: 'Lead',
    tierSavings: 'Risparmi per livello',
    exclusiveUpdates: 'Aggiornamento esclusivi',
    executiveSponsor: 'Sponsor esecutivo',
    merchandise: 'Articoli promozionali',
    certifiedUsers: 'Utenti certificati',
    noteAllowedOnce: 'Nota: il link precedente non può essere modificato una volta creato',
    saveLink: `Salva il link`,
    confirm: `Conferma`,
    copyLink: 'Copia il link',
    allowedCharactersError: 'Sono consentiti solo lettere, numeri, trattini e  trattini bassi (max 500 caratteri)',
    createSystemEstimatorLink: `Crea un link System Estimator personalizzato e condividilo con i tuoi clienti per ottenere lead. Tutti i lead generati da questo link verranno condivisi con te nel tuo gestore Enlighten.`,
    shareSystemEstimatorLink: `Condividi il tuo link System Estimator personalizzato con i tuoi clienti per ottenere lead. Tutti i lead generati da questo link verranno condivisi con te nel tuo gestore Enlighten.`,
    systemEstimatorLink: 'Link di System Estimator',
    confirmChanges: 'Conferma modifiche',
    confirmSELink: 'Conferma il tuo link al System Estimator. Questo link, dopo il salvataggio, non sarà modificabile.',
    copied: `Copiato`,
    mySELink: 'Il link del mio System Estimator',
    sdtUrlExistsError: 'This link is already in use by another installer. Please choose a different link',
    all: 'Tutti',
    filterText: 'Filtro',
    noProductAvailable: 'Nessun prodotto disponibile'
  }
};

export default einDashboard;
